<template>
	<Loading v-if="!ready" />
	<div v-else>
		<h2>{{ title }} - performed {{ perf.Performance }}</h2>
		<h4 v-if="authors.length"><span class="text-muted">written by </span><span v-for="(author, idx) in authors"> <span @click="inspectAuthor(author)" class="pointer">{{author.Author}}</span> <span>{{(idx===authors.length-1?'':' & ')}} </span></span></h4>
		<div v-if="perf.Notes && perf.Notes.trim().length">
			<p>{{ perf.Notes }}</p>
		</div>
		<h3 v-if="troupe.length" @click="inspectTroupe(troupe[0])" class="pointer">Troupe - <span>{{troupe[0].Troupe}}</span></h3>
		<div
			v-if="cast.length"
			>
			<b-list-group class="d-flex flex-row flex-wrap" flush>
				<b-list-group-item class="border-0 d-md-none w-100 pointer" v-for="cm in cast" @click="inspectCastMember(cm)" v-b-tooltip.hover :title="tooltip(cm)"> {{cm.Name}} </b-list-group-item>
				<b-list-group-item class="border-0 d-none d-md-block w-50 pointer" v-for="cm in cast" @click="inspectCastMember(cm)" v-b-tooltip.hover :title="tooltip(cm)"> {{cm.Name}} </b-list-group-item>
			</b-list-group>
		</div>
		<ModalGallery :photos="perf['Photos']" />
	</div>
</template>

<script>

import Vuex from 'vuex';

import ModalGallery from '../ModalGallery.vue'
import Loading from '../Loading.vue'

export default {
	name: "FeaturePerformance",
	components: { ModalGallery, Loading },
	computed: Vuex.mapState({
		authors: state => state.featured.performance.authors,
		title: state => state.featured.performance.title.Play,
		cast: state => state.featured.performance.cast,
		perf: state => state.featured.performance.performance,
		troupe: state => state.featured.performance.troupe,
		ready: state => state.featured.performance.ready
	}),
	created: function() {
		if(this.$store.state.featured.performance.performance.id !== this.$route.params.id) {
			this.$store.dispatch('featured/load', {
				type: 'PERF',
				id: this.$route.params.id,
			})
		}
	},
	methods: {
		tooltip(cm) {
			const nperf = cm['Number of Performances'] - 1;
			return nperf?`${nperf} other performance${nperf-1?'s':''}`:null
		},
		inspectCastMember(cm) {
			this.$store.dispatch('featured/inspect', {
				type: 'CAST',
				data: cm
			})
			this.$router.push({
				name: 'feature-member',
				params: {
					id: cm.id,
				}
			})
		},
		inspectTroupe(troupe) {
			this.$store.dispatch('featured/inspect', {
				type: 'TROUPE',
				data: troupe
			})
			this.$router.push({
				name: 'feature-troupe',
				params: {
					id: troupe.id,
				}
			})
		},
		inspectAuthor(author) {
			this.$store.dispatch('featured/inspect', {
				type: 'AUTHOR',
				data: author
			})
			this.$router.push({
				name: 'feature-author',
				params: {
					id: author.id,
				}
			})
		}

	}
}


</script>

<style>
.pointer {
	cursor: pointer;
}
</style>
